import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, switchMap, take, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectAuthState } from '../store/selectors/auth.selector';

@Injectable({
    providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
    constructor(private router: Router, private store: Store) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.store.select(selectAuthState).pipe(
            take(1),
            map((res) => {
                if (res.isLoggedIn) {
                    request = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${res.token}`,
                        },
                    });
                }
            }),
            switchMap(() =>
                next.handle(request).pipe(
                    tap(
                        () => {},
                        (err: any) => {
                            if (err instanceof HttpErrorResponse && this.router.url !== '/login') {
                                switch (err.status) {
                                    case 401:
                                        this.router.navigate(['/login'], { queryParams: { redirect: this.router.url } });
                                        break;
                                    case 403:
                                        this.router.navigate(['/login']);
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    )
                )
            )
        );
    }
}
